import { useState, useEffect } from 'react'

import PropTypes from 'prop-types'

import useTranslations from '../../../i18n/useTranslations'

import { IconButton, Tooltip, Typography } from '@mui/material'

import { ReactComponent as Copy } from '../../../assets/icons/copy.svg'

let notificationTimeout

const CopyTextButton = ({ textToCopy, sx }) => {
  const t = useTranslations()

  const [openSuccessNotification, setOpenSuccessNotification] = useState(false)

  const triggerNotification = () => {
    if (notificationTimeout) clearTimeout(notificationTimeout)

    setOpenSuccessNotification(true)

    notificationTimeout = setTimeout(() => {
      setOpenSuccessNotification(false)
    }, 1200)
  }

  const handleCopyText = () => {
    triggerNotification()
    return navigator.clipboard.writeText(textToCopy)
  }

  useEffect(() => {
    return () => {
      if (notificationTimeout) clearTimeout(notificationTimeout)
    }
  }, [])

  return (
    <Tooltip
      title={<Typography variant="body2">{t('action:text-copied')}</Typography>}
      disableFocusListener
      disableHoverListener
      disableInteractive
      classes={{ tooltip: 'info' }}
      open={openSuccessNotification}
    >
      <IconButton sx={sx} onClick={handleCopyText}>
        <Copy />
      </IconButton>
    </Tooltip>
  )
}

CopyTextButton.propTypes = {
  textToCopy: PropTypes.string,
  sx: PropTypes.object,
}

export default CopyTextButton
